import { showPreloaded, showTopicInLayerWithOptions } from 'OK/MediaLayer';

function activate(element) {
    var owner = element.getAttribute('data-owner'),
        topic = element.getAttribute('data-topic'),
        link = element.getAttribute('data-link'),
        instant = element.getAttribute('data-instant'),
        hobbyType = element.getAttribute('data-hobby-type'),
        hobbyCategory = element.getAttribute('data-hobby-category'),
        logPlace = element.getAttribute('data-log-place'),
        activity = element.getAttribute('data-activity') || '',
        commentsDisabled = element.getAttribute('data-comments-disabled') === '1',
        recoDisabled = element.getAttribute('data-reco-disabled') === '1';
    if (instant) {
        showPreloaded(owner, link);
    } else {
        showTopicInLayerWithOptions({
            topicId: topic,
            owner: owner,
            activityId: activity,
            needFocusComment: false,
            byShortlink: link,
            hobbyType: hobbyType,
            hobbyCategory: hobbyCategory,
            logPlace: logPlace,
            commentsDisabled: commentsDisabled,
            recoDisabled: recoDisabled
        });
    }
}

export default { activate };

export { activate };
